import React from "react";
import { IconProps } from "../icon";

export const MoonEclipseIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M20.002 6A10.006 10.006 0 0120 18.002M12 22a9.96 9.96 0 004.38-1.008 9 9 0 110-17.984A9.96 9.96 0 0012 2C6.477 2 2 6.477 2 12s4.477 10 10 10z"
    />
  </svg>
);
